module.exports = __webpack_public_path__ + "static/media/de.63382628.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/de.svg
// module id = 2075
// module chunks = 0